<script setup>
import { computed } from "vue";
import { twMerge } from "tailwind-merge";

const props = defineProps({
    color: {
        type: String,
        default: "gray",
    },
    class: String,
});

const colorClasses = computed(() => {
    switch (props.color) {
        case "primary":
            return "text-gray-900 bg-gray-50 ring-gray-300";
        case "red":
            return "text-red-400 bg-red-400/10 ring-red-400/20";
        case "green":
            return "text-green-400 bg-green-500/10 ring-green-500/20";
        case "yellow":
            return "text-yellow-500 bg-yellow-400/10 ring-yellow-400/20";
        case "orange":
            return "text-orange-400 bg-orange-400/10 ring-orange-400/20";
        case "black":
            return "text-white bg-gray-900 ring-gray-900/90 dark:bg-white dark:text-gray-900 dark:ring-white/90";
        case "real-black":
            return "text-white bg-black/70 ring-black/90";
        default:
            return "text-gray-400 bg-gray-400/10 ring-gray-400/20";
    }
});
</script>

<template>
    <span
        :class="[
            twMerge('inline-flex items-center px-2 py-1 text-xs font-medium rounded-md ring-1 ring-inset ring-gray-400/20 whitespace-nowrap', props.class),
            colorClasses,
        ]">
        <slot></slot>
    </span>
</template>
